<!-- bbs > 모니터링 상세설정 -->
<template>
  <div class="content-wrap">
    <NaviBox/>
    <div class="tit-group02">
      <h2 class="tit">{{t('message.monitoringDetailSettings')}}</h2>
    </div>

    <div class="content-box">
      <div class="form-group col-ty">
        <!--form-row-->
        <div class="form-row ty08">
          <div class="txt-tit">{{t('message.title')}}<span class="imp">*</span></div>
          <div class="row">
            <c-Input :placeholder="t('message.enterTitle')" class="size07" v-model="monitoringTitle" :name="'monitoringTitle'"/>
          </div>
        </div>
        <!--form-row-->
        <div class="form-row ty09">
          <div class="txt-tit">{{t('message.changeHistory')}}</div>
          <div class="row ">
            <v-btn class="txt03" @click="onClickChangeDialog">{{ changeCnt }}</v-btn>
          </div>
        </div>
        <!--form-row-->
      </div>
      <div class="form-group col-ty inner-ty01">
        <div class="group-tit">{{t('message.targetSettings')}}</div>
        <!--form-row-->
        <div class="form-row ty09">
          <div class="txt-tit">{{t('message.participationTarget')}}</div>
          <div class="row">
            <c-btn01 :btnText="t('message.add')" @click.prevent="onClickMemberPopup('1')"/>
            <v-btn class="txt03">{{targetCnt}}</v-btn>
          </div>
        </div>
        <!--form-row-->
        <div class="form-row ty09">
          <div class="txt-tit">{{t('message.auditParticipationTarget')}}</div>
          <div class="row">
            <c-btn01 :btnText="t('message.add')" @click.prevent="onClickMemberPopup('3')"/>
            <v-btn class="txt03">{{ auditTargetCnt }}</v-btn>
          </div>
        </div>
      </div>
      <div class="form-group col-ty inner-ty01">
        <div class="group-tit">{{t('message.dateAndCycleSettings')}}</div>
        <!--form-row-->
        <div class="form-row ty09">
          <div class="txt-tit">{{t('message.openDate')}}<span class="imp">*</span></div>
          <div class="row">
            <c-InputDate v-model="startDate" :name="'startDate'" :enableTimePicker="false" readonly="" />
          </div>
        </div>
        <!--form-row-->
        <div class="form-row ty09">
          <div class="txt-tit">{{t('message.endDate')}}<span class="imp">*</span></div>
          <div class="row">
            <c-InputDate v-model="endDate" :name="'endDate'" :enableTimePicker="false" readonly="" />
          </div>
        </div>
        <!--form-row-->
        <div class="form-row ty09">
          <div class="txt-tit">{{t('message.observationCycle')}}</div>
          <div class="row">
            <Select v-bind="periodTypeSelect" v-model="periodType" :name="'periodType'"/>
          </div>
        </div>
        <!--form-row-->
        <div class="form-row ty09">
          <div class="txt-tit">{{t('message.cycleStartDay')}}</div>
          <div class="row">
            <Select v-bind="periodStartDaySelect"v-model="periodStartDay" :name="'periodStartDay'"/>
            <v-btn class="txt03" @click="onClickPeriod">전체주기</v-btn>
          </div>
        </div>
        <!--form-row-->
        <div class="form-row ty09">
          <div class="txt-tit">{{t('message.requiredObservationCount')}}</div>
          <div class="row">
            <Select v-bind="periodCntSelect" v-model="periodCnt" :name="'periodCnt'"/>
          </div>
        </div>
        <!--form-row-->
      </div>
      <div class="form-group col-ty inner-ty01">
        <div class="group-tit">{{t('message.observationSettings')}}</div>
        <!--form-row-->
        <div class="form-row ty09">
          <div class="txt-tit">{{t('message.allowDuplicateObservations')}}</div>
          <div class="row">
            <v-switch v-model="duplicateYn" :name="'duplicateYn'" inset hide-details true-value="Y" false-value="N"/>
          </div>
        </div>
        <!--form-row-->
        <div class="form-row ty09">
          <div class="txt-tit">{{t('message.mandatorySaveSafetyTalk')}}</div>
          <div class="row">
            <v-switch v-model="timelineYn" :name="'timelineYn'" inset hide-details true-value="Y" false-value="N"/>
          </div>
        </div>
        <!--form-row-->
        <div class="form-row ty09">
          <div class="txt-tit">{{t('message.allowTempSave')}}</div>
          <div class="row">
            <v-switch v-model="tempYn" :name="'tempYn'" inset hide-details true-value="Y" false-value="N"/>
          </div>
        </div>
        <!--form-row-->
        <div class="form-row ty09">
          <div class="txt-tit">{{t('message.observationLocation')}}</div>
          <div class="row">
            <c-btn01 :btnText="t('message.addOrEdit')" @click.prevent="onClickPlace"/>
          </div>
        </div>
        <!--form-row-->
      </div>
      <div class="form-group col-ty inner-ty01">
        <div class="group-tit">{{t('message.reportSendSettings')}}</div>
        <!--form-row-->
        <div class="form-row ty09">
          <div class="txt-tit">{{t('message.reportSendDate')}}</div>
          <div class="row">
            <Select v-bind="reportDaySelect" v-model="reportDay" :name="'reportDay'"/>
          </div>
        </div>
        <!--form-row-->
        <div class="form-row ty09">
          <div class="txt-tit">{{t('message.autoReportSend')}}</div>
          <div class="row">
            <v-switch v-model="reportAutoYn" :name="'reportAutoYn'" inset hide-details true-value="Y" false-value="N"/>
          </div>
        </div>
        <!--form-row-->
      </div>
    </div>
    <div class="content-box ty01">
      <div class="sort-group">
        <div class="sort-row">
          <div class="wl">
            <div class="txt04">{{t('message.behavior')}}</div>
          </div>
          <div class="wr">
            <c-btnLine01 :btnText="t('message.loadData')" @click="onClickBehavior"/>
            <!-- <c-btn01 :btnText="t('message.add')" @click="onClickBehaviorAdd"/> -->
          </div>
        </div>
      </div>
      <div class="sortable-group">
        <div class="sortable-header">
          <div class="col">{{t('message.displayOrder')}}</div>
          <div class="col">{{t('message.behavior')}}</div>
          <div class="col">{{t('message.delete')}}</div>
        </div>
        <draggable
          v-model="behaviorItems"
          item-key="idx"
          tag="div"
          class="sortable-cont"
          animation="200"
          @end="onChange"
        >
        <template #item="{element, index}">
          <div class="draggable" :key="element.idx">
            <div class="col" aria-hidden="true">
              <img src="@/assets/img/format-align-justify.svg" alt="">
            </div>
            <div class="col">
              {{ element.behaviorTitle }}
            </div>
            <div class="col">
              <c-btn02 :btnText="t('message.delete')" class="sm" @click="onClickDeleteBehavior(element)"/>
            </div>
          </div>
        </template>
        </draggable>
      </div>
    </div>
    <div class="bottom-btn-group">
      <div class="wl">
        <c-btnLine01 :btnText="t('message.list')" @click.stop="onClickGoList()"/>
      </div>
      <div class="wr">
        <c-btn02 :btnText="t('message.preview')" @click="onClickDetail"/>
        <c-btn02 :btnText="t('message.delete')" @click="dialogDeleteModel=true" v-if="!utils.isEmpty(viewIdx)"/>
        <c-btn01 :btnText="t('message.registerOrUpdate')" @click="validateAll"/>
      </div>
    </div>
  </div>
  <!--일괄 대상자 변경-->
  <DialogTargetAdd2
    v-model="dialogChangeModel"
    @close="dialogChangeModel=false "
    @confirm="confirmMember"
  />
  <!--popup: 관찰장소-->
  <DialogObservationPlace
    v-model="dialogPlaceModel"
    :popTitle="t('message.observationLocation')"
    :popSubTitle="t('message.observationLocationListDescription')"
    @close="dialogPlaceModel=false"
    @confirm="confirmPlace"/>
  <!--popup: 주기별 상세날짜보기-->
  <c-dialog
    v-model="dialogPeriodModel"
    v-bind="dialogPeriodBind"
    @close="dialogPeriodModel=false"
  />
  <!--popup: 변경이력-->
  <c-dialog
    v-model="dialogChangeHistoryModel"
    v-bind="dialogChangeHistoryBind"
    :dialogText="historyDialogText"
    @close="dialogChangeHistoryModel=false"
  />
  <!--popup: 행동불러오기-->
  <DialogCallAction
    v-model="dialogBehaviorModel"
    :pop-title="t('message.loadAction')"
    @close="dialogBehaviorModel=false"
    @confirm="confirmBehavior"
  />
  <!--popup: 미리보기-->
  <DialogPreview
    v-model="dialogPreviewModel"
    :pop-title="t('message.preview')"
    @close="dialogPreviewModel=false"
  />
  <!--popup: 행동삭제-->
  <c-dialog
    v-model="dialogActionDeleteModel"
    v-bind="dialogActionDeleteBind"
    @close="dialogActionDeleteModel=false"
    @confirm="confirmDelete"
  />
  <!--popup: 삭제-->
  <c-dialog
    v-model="dialogDeleteModel"
    v-bind="dialogDeleteBind"
    @close="dialogDeleteModel=false"
  />
  <v-snackbar v-model="snackbar" :timeout="3000" location="center" class="custom-snackbar"> {{ snackText }} </v-snackbar>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useCommonStore } from "@/store/common";
import {Form, useForm} from "vee-validate";
import BbsService from "@/services/bbs.service";
import utils from "@/common/Utils";
import * as yup from "yup";
import _ from 'lodash';
import draggable from 'vuedraggable'
import dayjs from "dayjs";
import LogService from "@/services/log.service";
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

//store
const store = useCommonStore()
const storeRef = storeToRefs(store)
const route:any = useRoute()

//validation schema
const schema = yup.object().shape({
  monitoringTitle: yup.string().required(() => t('message.requiredField')),
});
const { validate } = useForm({ validationSchema: schema })

//bind
const snackbar = ref(false)
const snackText = ref('')
let viewIdx = route.params.idx!='null'?route.params.idx:''
const dialogChangeModel = ref(false)
const dialogPlaceModel = ref(false)
const dialogPeriodModel = ref(false)
const dialogChangeHistoryModel = ref(false)
const dialogBehaviorModel = ref(false)
const dialogPreviewModel = ref(false)
const dialogActionDeleteModel = ref(false)
const dialogDeleteModel = ref(false)
const monitoringInfo = ref({})
const monitoringTitle = ref('')
const startDate = ref('false')
const endDate = ref('false')
const periodType = ref('1')
const periodStartDay = ref('1')
const duplicateYn = ref('N')
const timelineYn = ref('N')
const tempYn = ref('Y')
const targetCnt = ref('0')
const monitoringTargets = ref([])
const auditTargetCnt = ref('0')
const auditTargets = ref([])
const reportAutoYn = ref('N')
const changeCnt = ref(0)
const historyDialogText = ref('')
const reportDay = ref('1')
const periodCnt = ref('1')
const places = ref([])
const behaviorItems = ref([])
let selectedBehavior = {}
let changeLog = []

//ui
const periodTypeSelect = ({items: [{name: '1'+t('message.week'), value: '1'}, {name: '2'+t('message.week'), value: '2'}, {name: '3'+t('message.week'), value: '3'}, {name: '4'+t('message.week'), value: '4'}, {name: '5'+t('message.week'), value: '5'}
    , {name: '6'+t('message.week'), value: '6'}, {name: t('message.oneMonth'), value: '10'}, {name: t('message.quarter'), value: '11'}, {name: t('message.halfYear'), value: '12'}, {name: t('message.year3'), value: '13'}]})
const periodStartDaySelect = ({items: [{name: t('message.monday'), value: '1'},{name: t('message.tuesday'), value: '2'},{name: t('message.wednesday'), value: '3'},{name: t('message.thursday'), value: '4'},
    {name: t('message.friday'), value: '5'},{name: t('message.saturday'), value: '6'},{name: t('message.sunday'), value: '7'}]})
const periodCntSelect = {items: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10']}
const reportDaySelect = {items: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20','21', '22', '23', '24', '25', '26', '27', '28', '29', '30','31']}
const dialogPeriodBind:any = ref({
  dialogTit: t('message.detailedCycleDates'),
  dialogText: '1회 : 2024.02.01 ~ 2024.02.07<br>2회 : 2024.02.08 ~ 2024.02.15<br>3회 : 2024.02.16~ 2024.02.23',
  btn1Text: t('message.confirm'),
  btn1Show: true,
})
const dialogChangeHistoryBind = {
  dialogTit: t('message.changeHistory'),
  dialogText: '생성 / admin / 2024.01.03 수정(제목) / admin / 2024.01.04<br>대상추가(3명) / admin / 2024.01.04<br>대상제거(1명) / admin / 2024.01.04<br>행동수정 / admin / 2024.01.04',
  btn1Text: t('message.confirm'),
  btn1Show: true,
}
const dialogActionDeleteBind = {
  dialogTit: t('message.changeHistory'),
  dialogText: t('message.deleteConfirmation'),
  btn1Text: t('message.confirm'),
  btn1Show: true,
}
const dialogDeleteBind = {
  dialogTit: t('message.delete'),
  dialogText: t('message.deleteConfirmation'),
  btn1Text: t('message.confirm'),
  btn1Show: true,
}

//hook
onMounted(() => {
  if (!utils.isEmpty(viewIdx)) {
    let params = {
      idx: viewIdx
    }

    BbsService.getBbs(params).then(
      (response) => {
        monitoringInfo.value = response.result
        monitoringTitle.value = response.result.monitoringTitle
        startDate.value = response.result.startDate ? dayjs(response.result.startDate).format('YYYY-MM-DD') : ''
        endDate.value = response.result.endDate ? dayjs(response.result.endDate).format('YYYY-MM-DD') : ''
        periodType.value = response.result.periodType
        periodStartDay.value = response.result.periodStartDay
        duplicateYn.value = response.result.duplicateYn
        timelineYn.value = response.result.timelineYn
        tempYn.value = response.result.tempYn
        targetCnt.value = response.result.targetCnt
        auditTargetCnt.value = response.result.auditTargetCnt
        monitoringTargets.value = response.result.monitoringTargets
        auditTargets.value = response.result.monitoringAuditTargets
        reportAutoYn.value = response.result.reportAutoYn
        changeCnt.value = response.result.changeCnt?response.result.changeCnt:0
        reportDay.value = response.result.reportDay
        periodCnt.value = response.result.periodCnt
        behaviorItems.value = response.result.monitoringBehaviors
      },
      (error) => {
        if(error.status == 403)
          utils.movePage('/login')
        else{
          snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
          snackbar.value = true
        }
      }
    )
  }
})

//function
const validateAll = async () => {
  const result = await validate(); // 전체 필드 검증 실행
  if(result.valid)
    handleForm()
}

const handleForm = ()=>{
  if(import.meta.env.MODE == 'development') {
    onClickGoList()
  }
  else{
    let companyIdx = localStorage.getItem('companyIdx')
    //코멘트리스트
    let behaviorArr = []
    behaviorItems.value.forEach((item)=>{
      behaviorArr.push({idx:item.idx})
    })

    let params = {
      idx:viewIdx,
      companyIdx:companyIdx,
      monitoringTitle:monitoringTitle.value,
      startDate:startDate.value,
      endDate:endDate.value,
      periodType:periodType.value,
      periodStartDay:periodStartDay.value,
      duplicateYn:duplicateYn.value,
      timelineYn:timelineYn.value,
      tempYn:tempYn.value,
      targetCnt:targetCnt.value,
      monitoringTargets:monitoringTargets.value,
      auditTargetCnt:auditTargetCnt.value,
      monitoringAuditTargets:auditTargets.value,
      monitoringPlaces:places.value,
      reportAutoYn:reportAutoYn.value,
      changeCnt:changeCnt.value,
      reportDay:reportDay.value,
      periodCnt:periodCnt.value,
      monitoringBehaviors:behaviorArr,
      changeLogList:changeLog
    }

    BbsService.insertBbs(params).then(
      (response) => {
        if(response.success) {
          viewIdx = null
          storeRef.viewIdx = null
          utils.movePage('/monitoringManagementList')
        }
        else{
          snackText.value = response.message
          snackbar.value = true
        }
      },
      (error) => {
        if(error.status == 403)
          utils.movePage('/login')
        else{
          snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
          snackbar.value = true
        }
      }
    )
  }
}
const onClickGoList = ()=>{
  utils.movePage('/monitoringManagementList')
}

const onClickMemberPopup = (type)=>{
  //대상타입 대상, audit
  storeRef.popupType.value = type
  //navi에서 모니터링에해당하는 대상맴버 검색 시 사용
  storeRef.popupItems.value = null
  storeRef.monitoringInfo.value = monitoringInfo.value
  //회원정보에서 대상맴버정보 넘겨서 사용, 양쪽다 포함될수 없어서 막는 용도로 사용
  if(type == '1') {
    storeRef.popupItems2.value = monitoringTargets.value
    storeRef.popupItemsExtra.value = auditTargets.value
  }
  else if(type == '3') {
    storeRef.popupItems2.value = auditTargets.value
    storeRef.popupItemsExtra.value = monitoringTargets.value
  }
  dialogChangeModel.value=true
}

const confirmMember = (params)=>{
  dialogChangeModel.value=false
  if(params !== false) {
    if(storeRef.popupType.value === '1') {
      targetCnt.value = params.length
      monitoringTargets.value = params
      if(!_.some(changeLog, 'targetMember'))
        changeLog.push('targetMember')
    }
    else if(storeRef.popupType.value === '3') {
      auditTargetCnt.value = params.length
      auditTargets.value = params
      if(!_.some(changeLog, 'auditMember'))
        changeLog.push('auditMember')
    }

    snackText.value = t('message.changeSuccess')
    snackbar.value = true
  }
}

const onClickPlace = ()=>{
  storeRef.popupIdx.value = viewIdx
  dialogPlaceModel.value=true
}

const confirmPlace = (params)=>{
  dialogPlaceModel.value=false
  places.value=params
  if(!_.some(changeLog, 'place'))
    changeLog.push('place')
}

const onClickBehavior = ()=>{
  storeRef.popupIdx.value = viewIdx
  storeRef.popupItems.value = behaviorItems.value
  storeRef.moduleType.value = '1'
  dialogBehaviorModel.value=true
  if(!_.some(changeLog, 'behavior'))
    changeLog.push('behavior')
}

const confirmBehavior = (params)=>{
  dialogBehaviorModel.value=false
  behaviorItems.value = params
}

const onClickPeriod = ()=>{
  let companyIdx = localStorage.getItem('companyIdx')
  if(!startDate.value || !endDate.value){
    snackText.value = t('message.selectDate')
    snackbar.value = true
    return
  }
  let params = {
    startDate: startDate.value,
    endDate: endDate.value,
    periodStartDay: periodStartDay.value,
    periodType: periodType.value
  }

  BbsService.getMonitoringPeriodList(params).then(
    (response) => {
      if(response.success) {
        dialogPeriodBind.value.dialogText = ''
        _.forEach(response.result, (val, key)=>{
          dialogPeriodBind.value.dialogText += val.periodSeq+' : '+val.startDate.replace('T00:00:00','')+' ~ '+val.endDate.replace('T00:00:00','')+'<br>'
        })
        dialogPeriodModel.value = true
      }
      else{
        snackText.value = response.message
        snackbar.value = true
      }
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}

const onClickDetail = ()=>{
  if(import.meta.env.MODE == 'development') {
    dialogPreviewModel.value=true
  }
  else{
    storeRef.popupIdx.value = viewIdx
    storeRef.popupItems.value = behaviorItems.value
    dialogPreviewModel.value=true
  }
}

const onClickChangeDialog = ()=>{
  let companyIdx = localStorage.getItem('companyIdx')
  let params = {
    tableType: 'bbs',
    parentIdx:viewIdx
  }
  LogService.getLogList(params).then(
    (response) => {
      let logContent = ''
      if(response.result.length > 0) {
        response.result.forEach((row)=> {
          logContent += `${row.changeLog} / ${row.memberId} / ${dayjs(row.regDate).format('YYYY-MM-DD HH:mm:ss')} <br>`
        });
      }

      if(logContent != '') {
        historyDialogText.value = utils.changeLogLanguage(logContent)
        dialogChangeHistoryModel.value=true
      }
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}

const onClickBehaviorAdd = ()=>{
  window.open("/actionManagementList", "_blank", "noopener,noreferrer");
}

const onClickDeleteBehavior=(item)=>{
  //dialogActionDeleteModel.value=true
  //selectedBehavior = item
  _.remove(behaviorItems.value, item)
}

const confirmDelete=()=>{
  let companyIdx = localStorage.getItem('companyIdx')
  if(!companyIdx)
    utils.movePage('/login')
  let params = {
    companyIdx:companyIdx,
    updateArr: [viewIdx],
  }

  BbsService.deleteBbs(params).then(
    (response) => {
      if(response.success) {
        onClickGoList()
        snackText.value = 'success'
        snackbar.value = true
      }
      else{
        snackText.value = response.message
        snackbar.value = true
      }
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}

const onChange = () => {
  console.log('최종 순서:', behaviorItems.value.map(v => v.idx))
}
</script>



<style lang="scss" scoped>
.sortable-group{
  .sortable-header ,.sortable-cont .draggable{
    .col:nth-child(1){flex-grow:0;width:15%;}
    .col:nth-child(2){justify-content:flex-start;text-align:left}
    .col:nth-child(3){flex-grow:0;width:15%;}
  }
}

</style>
